import script from "./CatalogSearchInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogSearchInput.vue?vue&type=script&setup=true&lang=ts"

import "./CatalogSearchInput.vue?vue&type=style&index=0&id=5251a1b9&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5251a1b9"]])

export default __exports__